module.exports = __webpack_public_path__ + "img/nashaa.6034060f.jpg";